import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { PrivateRoute, SuperAdminRoute } from './components/PrivateRoute';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ComplaintPage } from './pages/ComplaintPage';
import { InquiryDetailPage } from './pages/InquiryDetailPage';
import { NoticePage } from './pages/NoticePage';
import { NoticeWritePage } from './pages/NoticeWritePage';
import { NoticeDetailPage } from './pages/NoticeDetailPage';
import { RoutesPage } from './pages/RoutesPage';
import { RouteDetailPage } from './pages/RouteDetailPage';
import { BoardingPage } from './pages/BoardingPage';
import { OperationPage } from './pages/OperationPage';
import { OperationDetailPage } from './pages/OperationDetailPage';
import { StationOperationPage } from './pages/StationOperationPage';
import { StationOperationDetailPage } from './pages/StationOperationDetailPage';
import { DriverPage } from './pages/DriverPage';
import { MaintenancePage } from './pages/MaintenancePage';
import { AdminPage } from './pages/AdminPage';
import { ReportPage } from './pages/ReportPage';
import { SuggestionPage } from './pages/SuggestionPage';
import { SuggestionDetailPage } from './pages/SuggestionDetailPage';
import { ResidenceStatsPage } from './pages/ResidenceStatsPage';
import { AttachmentPage } from './pages/AttachmentPage';
import { PublicAttachmentPage } from './pages/PublicAttachmentPage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#667eea',
    },
    secondary: {
      main: '#764ba2',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicAttachmentPage fallback={<LoginPage />} />} />
            <Route path="/files/:attachmentId" element={<PublicAttachmentPage />} />

            {/* Protected Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/complaints" element={<ComplaintPage />} />
              <Route path="/cs/:inquiryId" element={<InquiryDetailPage />} />
              <Route path="/routes" element={<RoutesPage />} />
              <Route path="/routes/:routeId" element={<RouteDetailPage />} />
              <Route path="/driver" element={<DriverPage />} />
              <Route path="/maintenance" element={<MaintenancePage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/operation" element={<OperationPage />} />
              <Route path="/operation/:operationId" element={<OperationDetailPage />} />

              {/* Super Admin Only */}
              <Route element={<SuperAdminRoute />}>
                <Route path="/operation/stations" element={<StationOperationPage />} />
                <Route path="/operation/stations/:stationId" element={<StationOperationDetailPage />} />
                <Route path="/suggestions" element={<SuggestionPage />} />
                <Route path="/suggestions/:suggestionId" element={<SuggestionDetailPage />} />
                <Route path="/notices" element={<NoticePage />} />
                <Route path="/notices/new" element={<NoticeWritePage />} />
                <Route path="/notices/:noticeId" element={<NoticeDetailPage />} />
                <Route path="/boarding" element={<BoardingPage />} />
                <Route path="/reports" element={<ReportPage />} />
                <Route path="/residence-stats" element={<ResidenceStatsPage />} />
                <Route path="/attachments" element={<AttachmentPage />} />
              </Route>
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
